module.exports = __webpack_public_path__ + "6e8c927accefd5c090e89ce934e6231e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_15.jpg
// module id = 1697
// module chunks = 5